import { FaYoutube, FaFacebook, FaTiktok, FaInstagram } from "react-icons/fa";
import { PlaySquare } from "lucide-react";

const SOURCES = [
  { key: "All", label: "All", Icon: null },
  { key: "YouTube", label: "YouTube", Icon: FaYoutube },
  { key: "TikTok", label: "TikTok", Icon: FaTiktok },
  { key: "Reels", label: "Reels", Icon: FaInstagram },
  { key: "Shorts", label: "Shorts", Icon: PlaySquare },
  { key: "Facebook", label: "Facebook", Icon: FaFacebook },
];

export function SourceFilters({ active, onChange }) {
  return (
    <div className="px-4 mt-1">
      <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide py-1">
        <span className="text-white/50 text-xs tracking-wide uppercase mr-1">Source:</span>
        {SOURCES.map(({ key, label, Icon }) => {
          const isActive = key === active;
          return (
            <button
              key={key}
              data-testid={`src-${key.toLowerCase()}`}
              onClick={() => onChange(key)}
              className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium whitespace-nowrap transition ${
                isActive
                  ? "bg-brand text-white shadow-[0_0_14px_rgba(230,59,46,0.4)]"
                  : "bg-bg-surface border border-white/10 text-white/75 hover:bg-white/5"
              }`}
            >
              {Icon && <Icon size={12} />}
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
